document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('.menu-toggle');
const nav = document.querySelector('#PrimaryNavigation');

if (menuToggle && nav) {
  menuToggle.addEventListener('click', () => {
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
    nav.classList.toggle('is-open', !expanded);
  });
}

document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
  const trigger = menu.querySelector('[data-mega-trigger]');
  let closeTimer;

  const setOpen = (open) => {
    window.clearTimeout(closeTimer);
    menu.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', String(open));
  };

  menu.addEventListener('mouseenter', () => setOpen(true));
  menu.addEventListener('mouseleave', () => {
    closeTimer = window.setTimeout(() => setOpen(false), 220);
  });

  menu.addEventListener('focusin', () => setOpen(true));
  menu.addEventListener('focusout', (event) => {
    if (!menu.contains(event.relatedTarget)) {
      closeTimer = window.setTimeout(() => setOpen(false), 120);
    }
  });

  trigger?.addEventListener('click', (event) => {
    const prefersTouchMenu = window.matchMedia('(max-width: 749px), (pointer: coarse)').matches;
    if (!prefersTouchMenu || menu.classList.contains('is-open')) return;
    event.preventDefault();
    setOpen(true);
  });
});

document.querySelectorAll('[data-announcement-rotator]').forEach((rotator) => {
  const items = Array.from(rotator.querySelectorAll('.announcement-bar__item'));
  if (items.length <= 1) return;

  let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;

  window.setInterval(() => {
    items[activeIndex]?.classList.remove('is-active');
    activeIndex = (activeIndex + 1) % items.length;
    items[activeIndex]?.classList.add('is-active');
  }, Number(rotator.dataset.speed) || 5000);
});

document.querySelectorAll('[data-sticky-promo]').forEach((promo) => {
  const toggle = promo.querySelector('[data-sticky-promo-toggle]');
  const close = promo.querySelector('[data-sticky-promo-close]');

  const setOpen = (open) => {
    promo.setAttribute('aria-expanded', String(open));
  };

  toggle?.addEventListener('click', () => {
    setOpen(promo.getAttribute('aria-expanded') !== 'true');
  });

  close?.addEventListener('click', () => setOpen(false));
});

const formatMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format((cents || 0) / 100);
};

const escapeHtml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartDrawerPanel = cartDrawer?.querySelector('.cart-drawer__panel');
const cartDrawerItems = cartDrawer?.querySelector('[data-cart-drawer-items]');
const cartDrawerSubtotal = cartDrawer?.querySelector('[data-cart-drawer-subtotal]');
const freeShippingMeter = cartDrawer?.querySelector('[data-free-shipping]');
const cartUpsellPopup = document.querySelector('[data-cart-upsell-popup]');
const cartUpsellPanel = cartUpsellPopup?.querySelector('.cart-upsell-popup__panel');

const updateFreeShippingMeter = (cart, root = freeShippingMeter) => {
  if (!root || !cart) return;

  const threshold = Number(root.dataset.threshold) || 10000;
  const progress = root.querySelector('[data-free-shipping-progress], [data-free-shipping-section-progress]');
  const message = root.querySelector('[data-free-shipping-message], [data-free-shipping-section-message]');
  const total = cart.total_price || 0;
  const remaining = Math.max(0, threshold - total);
  const percentage = Math.min(100, Math.round((total / threshold) * 100));

  if (progress) progress.style.width = `${percentage}%`;
  if (message) {
    message.textContent = remaining > 0
      ? `${formatMoney(remaining)} away from complimentary shipping.`
      : 'Complimentary shipping unlocked.';
  }
};

const openCartDrawer = () => {
  if (!cartDrawer) return;
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('cart-drawer-open');
  cartDrawerPanel?.focus();
};

const closeCartDrawer = () => {
  if (!cartDrawer) return;
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('cart-drawer-open');
};

const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach((node) => {
    node.textContent = count;
  });
};

const addVariantToCart = async (variantId, quantity = 1) => {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity,
    }),
  });
  if (!response.ok) throw new Error('Unable to add item');
  return response.json();
};

const renderCartDrawer = (cart) => {
  if (!cartDrawerItems || !cartDrawerSubtotal) return;

  updateCartCount(cart.item_count);
  cartDrawerSubtotal.textContent = formatMoney(cart.total_price);
  updateFreeShippingMeter(cart);

  if (!cart.items.length) {
    cartDrawerItems.innerHTML = '<p class="cart-drawer__empty">Your cart is currently empty.</p>';
    return;
  }

  cartDrawerItems.innerHTML = cart.items.map((item, index) => {
    const image = item.image
      ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy">`
      : '';

    return `
      <div class="cart-drawer-item">
        <a class="cart-drawer-item__media" href="${item.url}">${image}</a>
        <div class="cart-drawer-item__content">
          <a href="${item.url}">${item.product_title}</a>
          <p>${item.variant_title || ''}</p>
          <div class="cart-drawer-item__actions">
            <span>Qty ${item.quantity}</span>
            <button type="button" data-cart-remove="${index + 1}">Remove</button>
          </div>
        </div>
        <strong>${formatMoney(item.final_line_price)}</strong>
      </div>
    `;
  }).join('');
};

const fetchCart = async () => {
  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Unable to fetch cart');
  return response.json();
};

const refreshCartDrawer = async () => {
  const cart = await fetchCart();
  renderCartDrawer(cart);
  return cart;
};

const openCartUpsellPopup = () => {
  if (!cartUpsellPopup) return false;
  cartUpsellPopup.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('cart-upsell-popup-open');
  cartUpsellPanel?.focus();
  return true;
};

const closeCartUpsellPopup = () => {
  if (!cartUpsellPopup) return;
  cartUpsellPopup.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('cart-upsell-popup-open');
};

const showPostAddCart = async () => {
  await refreshCartDrawer();
  if (!openCartUpsellPopup()) openCartDrawer();
};

document.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
  button.addEventListener('click', closeCartDrawer);
});

document.querySelectorAll('[data-cart-upsell-popup-close]').forEach((button) => {
  button.addEventListener('click', closeCartUpsellPopup);
});

document.querySelectorAll('.icon-link--cart').forEach((link) => {
  link.addEventListener('click', async (event) => {
    if (!cartDrawer) return;
    event.preventDefault();
    await refreshCartDrawer();
    openCartDrawer();
  });
});

cartDrawerItems?.addEventListener('click', async (event) => {
  const removeButton = event.target.closest('[data-cart-remove]');
  if (!removeButton) return;
  removeButton.disabled = true;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: Number(removeButton.dataset.cartRemove),
      quantity: 0,
    }),
  });

  await refreshCartDrawer();
});

cartDrawer?.addEventListener('click', async (event) => {
  const addButton = event.target.closest('[data-cart-upsell-add]');
  if (!addButton) return;

  addButton.disabled = true;
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: Number(addButton.dataset.cartUpsellAdd),
        quantity: 1,
      }),
    });
    if (!response.ok) throw new Error('Unable to add upsell');
    await refreshCartDrawer();
  } finally {
    addButton.disabled = false;
  }
});

cartUpsellPopup?.addEventListener('click', async (event) => {
  const viewCartButton = event.target.closest('[data-cart-upsell-view-cart]');
  if (viewCartButton) {
    closeCartUpsellPopup();
    await refreshCartDrawer();
    openCartDrawer();
    return;
  }

  const addButton = event.target.closest('[data-cart-upsell-popup-add]');
  if (!addButton) return;

  addButton.disabled = true;
  addButton.setAttribute('aria-busy', 'true');
  try {
    await addVariantToCart(addButton.dataset.cartUpsellPopupAdd);
    await refreshCartDrawer();
    addButton.textContent = 'Added';
  } finally {
    addButton.disabled = false;
    addButton.removeAttribute('aria-busy');
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeCartDrawer();
    closeCartUpsellPopup();
    closeSearchOverlay();
    closeQuickView();
    if (typeof closeWishlist === 'function') closeWishlist();
    if (typeof closeCompare === 'function') closeCompare();
  }
});

document.querySelectorAll('.product-form').forEach((form) => {
  form.addEventListener('click', (event) => {
    const button = event.target.closest('[data-variant-button]');
    if (!button) return;

    const select = form.querySelector('select[name="id"]');
    if (!select) return;

    select.value = button.dataset.variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    form.querySelectorAll('[data-variant-button]').forEach((variantButton) => {
      variantButton.classList.toggle('is-selected', variantButton === button);
    });
  });

  form.addEventListener('submit', async (event) => {
    if (!cartDrawer || !window.fetch) return;
    event.preventDefault();

    const submitButton = event.submitter || form.querySelector('[type="submit"]');
    submitButton?.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) throw new Error('Unable to add item');

      await showPostAddCart();
    } catch (error) {
      form.submit();
    } finally {
      submitButton?.removeAttribute('aria-busy');
    }
  });
});

const stickyAtc = document.querySelector('[data-sticky-atc]');
const productForm = document.querySelector('.product-form');

if (stickyAtc && productForm) {
  const updateStickyAtc = () => {
    const formBottom = productForm.getBoundingClientRect().bottom;
    stickyAtc.classList.toggle('is-visible', formBottom < 0);
  };

  updateStickyAtc();
  window.addEventListener('scroll', updateStickyAtc, { passive: true });
  window.addEventListener('resize', updateStickyAtc);
}

document.querySelectorAll('[data-free-shipping-section]').forEach(async (section) => {
  try {
    const cart = await fetchCart();
    updateFreeShippingMeter(cart, section);
  } catch (error) {
    section.hidden = true;
  }
});

document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
  const items = Array.from(builder.querySelectorAll('[data-bundle-item]'));
  const count = builder.querySelector('[data-bundle-count]');
  const total = builder.querySelector('[data-bundle-total]');
  const addButton = builder.querySelector('[data-bundle-add]');

  const updateBundle = () => {
    const selected = items.filter((item) => item.checked);
    const cents = selected.reduce((sum, item) => sum + (Number(item.dataset.price) || 0), 0);
    if (count) count.textContent = `${selected.length} selected`;
    if (total) total.textContent = formatMoney(cents);
    if (addButton) addButton.disabled = selected.length === 0;
  };

  items.forEach((item) => item.addEventListener('change', updateBundle));
  updateBundle();

  addButton?.addEventListener('click', async () => {
    const selected = items.filter((item) => item.checked && !item.disabled);
    if (!selected.length) return;

    addButton.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: selected.map((item) => ({
            id: Number(item.value),
            quantity: 1,
          })),
        }),
      });
      if (!response.ok) throw new Error('Unable to add bundle');
      selected.forEach((item) => {
        item.checked = false;
      });
      updateBundle();
      await refreshCartDrawer();
      openCartDrawer();
    } finally {
      addButton.removeAttribute('aria-busy');
    }
  });
});

document.querySelectorAll('[data-size-finder]').forEach((finder) => {
  const height = finder.querySelector('[data-size-height]');
  const build = finder.querySelector('[data-size-build]');
  const fit = finder.querySelector('[data-size-fit]');
  const result = finder.querySelector('[data-size-result]');
  const sizes = ['S', 'M', 'L', 'XL', '2XL'];

  const updateSize = () => {
    let index = 1;
    if (height?.value === 'short') index -= 1;
    if (height?.value === 'tall') index += 1;
    if (build?.value === 'broad') index += 1;
    if (build?.value === 'lean') index -= 1;
    if (fit?.value === 'oversized') index += 1;
    if (fit?.value === 'true') index -= 0;
    index = Math.max(0, Math.min(sizes.length - 1, index));
    const size = sizes[index];

    if (result) {
      result.innerHTML = `
        <span>Recommended</span>
        <strong>${size}</strong>
        <p>Start with ${size}. Size up if you want a stronger oversized streetwear fit.</p>
      `;
    }
  };

  [height, build, fit].forEach((field) => field?.addEventListener('change', updateSize));
  updateSize();
});

const searchOverlay = document.querySelector('[data-search-overlay]');
const searchPanel = searchOverlay?.querySelector('.search-overlay__panel');
const searchInput = searchOverlay?.querySelector('[data-search-input]');
const searchResults = searchOverlay?.querySelector('[data-search-results]');
let searchTimer;

const renderSearchGroup = (heading, items, renderItem) => {
  if (!items?.length) return '';
  return `
    <div class="search-result-group">
      <h3>${heading}</h3>
      <div>${items.map(renderItem).join('')}</div>
    </div>
  `;
};

const openSearchOverlay = () => {
  if (!searchOverlay) return;
  searchOverlay.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('search-overlay-open');
  window.setTimeout(() => searchInput?.focus(), 60);
};

function closeSearchOverlay() {
  if (!searchOverlay) return;
  searchOverlay.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('search-overlay-open');
}

document.querySelectorAll('[data-search-open]').forEach((trigger) => {
  trigger.addEventListener('click', (event) => {
    if (!searchOverlay) return;
    event.preventDefault();
    openSearchOverlay();
  });
});

document.querySelectorAll('[data-search-close]').forEach((trigger) => {
  trigger.addEventListener('click', closeSearchOverlay);
});

searchInput?.addEventListener('input', () => {
  window.clearTimeout(searchTimer);
  const query = searchInput.value.trim();

  if (!query) {
    if (searchResults) searchResults.innerHTML = '<p>Start typing to see product suggestions.</p>';
    return;
  }

  searchTimer = window.setTimeout(async () => {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article,query&resources[limit]=6`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Unable to search');
      const data = await response.json();
      const results = data.resources?.results || {};
      const products = results.products || [];
      const collections = results.collections || [];
      const pages = results.pages || [];
      const articles = results.articles || [];
      const queries = results.queries || results.query_suggestions || [];

      if (!products.length && !collections.length && !pages.length && !articles.length && !queries.length) {
        if (searchResults) searchResults.innerHTML = '<p>No products found. Try hoodie, tee, or drop.</p>';
        return;
      }

      if (searchResults) {
        searchResults.innerHTML = [
          renderSearchGroup('Products', products, (product) => `
            <a class="search-result search-result--product" href="${product.url}">
              ${product.image ? `<img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<span>L</span>'}
              <span>
                <strong>${escapeHtml(product.title)}</strong>
                <small>${escapeHtml(product.price || '')}</small>
              </span>
            </a>
          `),
          renderSearchGroup('Collections', collections, (collection) => `
            <a class="search-result search-result--compact" href="${collection.url}">
              <span>C</span>
              <span>
                <strong>${escapeHtml(collection.title)}</strong>
                <small>Collection</small>
              </span>
            </a>
          `),
          renderSearchGroup('Pages and journal', [...pages, ...articles], (item) => `
            <a class="search-result search-result--compact" href="${item.url}">
              <span>${item.type === 'article' ? 'J' : 'P'}</span>
              <span>
                <strong>${escapeHtml(item.title)}</strong>
                <small>${item.type === 'article' ? 'Journal' : 'Page'}</small>
              </span>
            </a>
          `),
          renderSearchGroup('Suggested searches', queries, (item) => {
            const text = item.text || item.styled_text || item.title || item;
            return `
              <a class="search-result search-result--query" href="/search?q=${encodeURIComponent(text)}">
                <span>?</span>
                <span>
                  <strong>${escapeHtml(text)}</strong>
                  <small>Search suggestion</small>
                </span>
              </a>
            `;
          }),
        ].join('');
      }
    } catch (error) {
      if (searchResults) searchResults.innerHTML = '<p>Search is taking a second. Press enter to view all results.</p>';
    }
  }, 180);
});

document.querySelectorAll('[data-collection-filters]').forEach((form) => {
  const toggle = document.querySelector(`[data-filter-toggle][aria-controls="${form.id}"]`);
  const sort = form.querySelector('[data-collection-sort]');

  toggle?.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    form.classList.toggle('is-open', !expanded);
  });

  sort?.addEventListener('change', () => {
    form.submit();
  });
});

const quickView = document.querySelector('[data-quick-view]');
const quickViewPanel = quickView?.querySelector('.quick-view__panel');
const quickViewMedia = quickView?.querySelector('[data-quick-view-media]');
const quickViewTitle = quickView?.querySelector('[data-quick-view-title]');
const quickViewVendor = quickView?.querySelector('[data-quick-view-vendor]');
const quickViewPrice = quickView?.querySelector('[data-quick-view-price]');
const quickViewVariants = quickView?.querySelector('[data-quick-view-variants]');
const quickViewForm = quickView?.querySelector('[data-quick-view-form]');
const quickViewLink = quickView?.querySelector('[data-quick-view-link]');

const openQuickView = () => {
  if (!quickView) return;
  quickView.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('quick-view-open');
  quickViewPanel?.focus();
};

const closeQuickView = () => {
  if (!quickView) return;
  quickView.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('quick-view-open');
};

document.querySelectorAll('[data-quick-view-close]').forEach((button) => {
  button.addEventListener('click', closeQuickView);
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-view-handle]');
  if (!button) return;

  event.preventDefault();
  button.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`/products/${button.dataset.quickViewHandle}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to load product');
    const product = await response.json();
    const image = product.featured_image || product.images?.[0];
    const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];

    if (quickViewMedia) {
      quickViewMedia.innerHTML = image
        ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy">`
        : '<span>LUNOVA</span>';
    }
    if (quickViewTitle) quickViewTitle.textContent = product.title;
    if (quickViewVendor) quickViewVendor.textContent = product.vendor || 'Quick view';
    if (quickViewPrice) quickViewPrice.textContent = formatMoney(firstAvailable?.price || product.price);
    if (quickViewLink) quickViewLink.href = product.url || `/products/${product.handle}`;
    if (quickViewVariants) {
      quickViewVariants.innerHTML = product.variants.map((variant) => `
        <option value="${variant.id}" ${variant.available ? '' : 'disabled'} ${variant.id === firstAvailable?.id ? 'selected' : ''}>
          ${escapeHtml(variant.title)} - ${formatMoney(variant.price)}${variant.available ? '' : ' - Sold out'}
        </option>
      `).join('');
    }
    openQuickView();
  } catch (error) {
    window.location.href = `/products/${button.dataset.quickViewHandle}`;
  } finally {
    button.removeAttribute('aria-busy');
  }
});

quickViewVariants?.addEventListener('change', () => {
  const selected = quickViewVariants.options[quickViewVariants.selectedIndex];
  const priceMatch = selected?.textContent?.match(/\$[\d,.]+/);
  if (quickViewPrice && priceMatch) quickViewPrice.textContent = priceMatch[0];
});

quickViewForm?.addEventListener('submit', async (event) => {
  event.preventDefault();
  const variantId = quickViewVariants?.value;
  if (!variantId) return;

  const submitButton = event.submitter || quickViewForm.querySelector('[type="submit"]');
  submitButton?.setAttribute('aria-busy', 'true');
  try {
    await addVariantToCart(variantId);
    closeQuickView();
    await showPostAddCart();
  } finally {
    submitButton?.removeAttribute('aria-busy');
  }
});

document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
  const buttons = Array.from(tabs.querySelectorAll('[data-product-tab-button]'));
  const panels = Array.from(tabs.querySelectorAll('[data-product-tab-panel]'));

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const index = button.dataset.productTabButton;
      buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.productTabPanel === index);
      });
    });
  });
});

document.querySelectorAll('[data-promo-popup]').forEach((popup) => {
  const frequency = popup.dataset.frequency || 'session';
  const trigger = popup.dataset.trigger || 'delay';
  const key = 'lunova_promo_popup_seen';
  const delay = Number(popup.dataset.delay) || 6000;
  const now = Date.now();
  const previous = Number(window.localStorage.getItem(key) || window.sessionStorage.getItem(key) || 0);
  const week = 7 * 24 * 60 * 60 * 1000;
  const shouldShow = frequency === 'always'
    || (frequency === 'session' && !window.sessionStorage.getItem(key))
    || (frequency === 'week' && now - previous > week);

  const closePopup = () => {
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('promo-popup-open');
    window.sessionStorage.setItem(key, String(now));
    window.localStorage.setItem(key, String(now));
  };

  popup.querySelectorAll('[data-promo-popup-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  const openPopup = () => {
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('promo-popup-open');
  };

  if (shouldShow) {
    if (trigger === 'delay' || trigger === 'both') {
      window.setTimeout(openPopup, delay);
    }

    if (trigger === 'exit' || trigger === 'both') {
      document.addEventListener('mouseleave', (event) => {
        if (event.clientY <= 0 && popup.getAttribute('aria-hidden') === 'true') openPopup();
      }, { once: true });
    }
  }
});

document.querySelectorAll('[data-delivery-estimator]').forEach((estimator) => {
  const min = Number(estimator.dataset.min) || 4;
  const max = Number(estimator.dataset.max) || 8;
  const output = estimator.querySelector('[data-delivery-window]');
  if (!output) return;

  const formatDate = (offset) => {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(date);
  };

  output.textContent = `${formatDate(min)} - ${formatDate(max)}`;
});

document.querySelectorAll('[data-modal-open]').forEach((button) => {
  button.addEventListener('click', () => {
    const modal = document.getElementById(button.dataset.modalOpen);
    if (modal?.showModal) modal.showModal();
  });
});

document.querySelectorAll('[data-modal-close]').forEach((button) => {
  button.addEventListener('click', () => {
    button.closest('dialog')?.close();
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('[data-gallery-main-image]');
  const mainArea = gallery.querySelector('.product-gallery__main');
  const zoomButton = gallery.querySelector('[data-gallery-zoom]');
  const lightbox = document.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');

  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage && !mainArea) return;

      if (thumb.dataset.full && mainImage) {
        mainImage.src = thumb.dataset.full;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.alt || '';
      }

      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        item.classList.toggle('is-active', item === thumb);
      });
    });
  });

  gallery.querySelectorAll('[data-gallery-video]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainArea || !thumb.dataset.videoHtml) return;
      mainArea.innerHTML = `<div class="product-gallery__video">${thumb.dataset.videoHtml}</div>`;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        item.classList.toggle('is-active', item === thumb);
      });
    });
  });

  zoomButton?.addEventListener('click', () => {
    if (!lightbox || !lightboxImage || !mainImage?.src) return;
    lightboxImage.src = mainImage.currentSrc || mainImage.src;
    lightboxImage.alt = mainImage.alt || '';
    lightbox.showModal();
  });
});

document.querySelectorAll('[data-lightbox-close]').forEach((button) => {
  button.addEventListener('click', () => {
    button.closest('dialog')?.close();
  });
});

const wishlistKey = 'lunova_wishlist';
const wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
const wishlistItems = wishlistDrawer?.querySelector('[data-wishlist-items]');
const wishlistPageItems = document.querySelector('[data-wishlist-page-items]');
const wishlistPanel = wishlistDrawer?.querySelector('.wishlist-drawer__panel');

const readWishlist = () => {
  try {
    return JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
  } catch (error) {
    window.localStorage.removeItem(wishlistKey);
    return [];
  }
};

const writeWishlist = (items) => {
  window.localStorage.setItem(wishlistKey, JSON.stringify(items.slice(0, 24)));
};

const renderWishlist = () => {
  const items = readWishlist();
  document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
    node.textContent = items.length;
  });

  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const active = items.some((item) => item.handle === button.dataset.productHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  const wishlistMarkup = items.map((item) => `
    <article class="wishlist-item">
      <a class="wishlist-item__media" href="${item.url}">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<span>L</span>'}
      </a>
      <div>
        <a href="${item.url}">${escapeHtml(item.title)}</a>
        <span>${escapeHtml(item.price)}</span>
        <button type="button" data-wishlist-remove="${escapeHtml(item.handle)}">Remove</button>
      </div>
    </article>
  `).join('');

  if (wishlistItems && !items.length) {
    wishlistItems.innerHTML = '<p class="wishlist-drawer__empty">Save pieces while you browse the drop.</p>';
  } else if (wishlistItems) {
    wishlistItems.innerHTML = wishlistMarkup;
  }

  if (wishlistPageItems && items.length) {
    wishlistPageItems.innerHTML = wishlistMarkup;
  }
};

const openWishlist = () => {
  if (!wishlistDrawer) return;
  wishlistDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('wishlist-drawer-open');
  wishlistPanel?.focus();
};

const closeWishlist = () => {
  if (!wishlistDrawer) return;
  wishlistDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('wishlist-drawer-open');
};

document.querySelectorAll('[data-wishlist-open]').forEach((button) => {
  button.addEventListener('click', () => {
    renderWishlist();
    openWishlist();
  });
});

document.querySelectorAll('[data-wishlist-close]').forEach((button) => {
  button.addEventListener('click', closeWishlist);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-toggle]');
  if (!button) return;

  const product = {
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
  };

  const items = readWishlist();
  const exists = items.some((item) => item.handle === product.handle);
  writeWishlist(exists ? items.filter((item) => item.handle !== product.handle) : [product, ...items]);
  renderWishlist();
});

wishlistItems?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-remove]');
  if (!button) return;
  writeWishlist(readWishlist().filter((item) => item.handle !== button.dataset.wishlistRemove));
  renderWishlist();
});

wishlistPageItems?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-remove]');
  if (!button) return;
  writeWishlist(readWishlist().filter((item) => item.handle !== button.dataset.wishlistRemove));
  renderWishlist();
});

renderWishlist();

const compareKey = 'lunova_compare';
const compareLimit = Number(document.querySelector('[data-compare-drawer]')?.dataset.limit) || 3;
const compareDrawer = document.querySelector('[data-compare-drawer]');
const compareItems = compareDrawer?.querySelector('[data-compare-items]');
const comparePageItems = document.querySelector('[data-compare-page-items]');
const comparePanel = compareDrawer?.querySelector('.compare-drawer__panel');

const readCompare = () => {
  try {
    return JSON.parse(window.localStorage.getItem(compareKey) || '[]');
  } catch (error) {
    window.localStorage.removeItem(compareKey);
    return [];
  }
};

const writeCompare = (items) => {
  window.localStorage.setItem(compareKey, JSON.stringify(items.slice(0, compareLimit)));
};

const renderCompare = () => {
  const items = readCompare();
  document.querySelectorAll('[data-compare-toggle]').forEach((button) => {
    const active = items.some((item) => item.handle === button.dataset.productHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  if (compareItems && !items.length) {
    compareItems.innerHTML = `<p class="compare-drawer__empty">Choose up to ${compareLimit} products to compare fit, fabric, price, and availability.</p>`;
  }

  const compareMarkup = items.length ? `
    <div class="compare-table" style="--compare-columns: ${items.length};">
      ${items.map((item) => `
        <article class="compare-card">
          <a class="compare-card__media" href="${item.url}">
            ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<span>L</span>'}
          </a>
          <h3><a href="${item.url}">${escapeHtml(item.title)}</a></h3>
          <dl>
            <div><dt>Price</dt><dd>${escapeHtml(item.price)}</dd></div>
            <div><dt>Fit</dt><dd>${escapeHtml(item.fit || 'Relaxed fit')}</dd></div>
            <div><dt>Fabric</dt><dd>${escapeHtml(item.fabric || 'Heavyweight')}</dd></div>
            <div><dt>Options</dt><dd>${escapeHtml(item.sizes || 'Size guide')}</dd></div>
            <div><dt>Status</dt><dd>${escapeHtml(item.status || 'Available')}</dd></div>
          </dl>
          <button type="button" data-compare-remove="${escapeHtml(item.handle)}">Remove</button>
        </article>
      `).join('')}
    </div>
  ` : '';

  if (compareItems && compareMarkup) compareItems.innerHTML = compareMarkup;
  if (comparePageItems && compareMarkup) comparePageItems.innerHTML = compareMarkup;
};

const openCompare = () => {
  if (!compareDrawer) return;
  compareDrawer.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('compare-drawer-open');
  comparePanel?.focus();
};

const closeCompare = () => {
  if (!compareDrawer) return;
  compareDrawer.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('compare-drawer-open');
};

document.querySelectorAll('[data-compare-close]').forEach((button) => {
  button.addEventListener('click', closeCompare);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-compare-toggle]');
  if (!button) return;

  const product = {
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    fit: button.dataset.productFit,
    fabric: button.dataset.productFabric,
    sizes: button.dataset.productSizes,
    status: button.dataset.productStatus,
  };

  const items = readCompare();
  const exists = items.some((item) => item.handle === product.handle);
  writeCompare(exists ? items.filter((item) => item.handle !== product.handle) : [product, ...items]);
  renderCompare();
  if (!exists) openCompare();
});

compareItems?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-compare-remove]');
  if (!button) return;
  writeCompare(readCompare().filter((item) => item.handle !== button.dataset.compareRemove));
  renderCompare();
});

document.querySelector('[data-compare-clear]')?.addEventListener('click', () => {
  writeCompare([]);
  renderCompare();
});

renderCompare();

document.querySelectorAll('[data-cookie-bar]').forEach((bar) => {
  if (window.localStorage.getItem('lunova_cookie_accept') === 'true') return;
  bar.setAttribute('aria-hidden', 'false');
  bar.querySelector('[data-cookie-accept]')?.addEventListener('click', () => {
    window.localStorage.setItem('lunova_cookie_accept', 'true');
    bar.setAttribute('aria-hidden', 'true');
  });
});

document.querySelectorAll('[data-social-proof]').forEach((toast) => {
  const close = () => {
    toast.setAttribute('aria-hidden', 'true');
    toast.dataset.dismissed = 'true';
  };
  toast.querySelector('[data-social-proof-close]')?.addEventListener('click', close);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const messages = [
    toast.querySelector('[data-social-proof-message]')?.textContent || '',
    toast.dataset.messageTwo,
    toast.dataset.messageThree,
    toast.dataset.messageFour
  ].filter(Boolean);
  let index = 0;

  window.setInterval(() => {
    if (toast.dataset.dismissed === 'true') return;
    index = (index + 1) % messages.length;
    const message = toast.querySelector('[data-social-proof-message]');
    if (message) message.textContent = messages[index];
    toast.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => {
      if (toast.dataset.dismissed !== 'true') toast.setAttribute('aria-hidden', 'true');
    }, 5200);
  }, Number(toast.dataset.interval) || 12000);
});

const padCountdown = (value) => String(Math.max(0, value)).padStart(2, '0');

document.querySelectorAll('[data-countdown]').forEach((timer) => {
  const target = new Date(timer.dataset.countdown);
  if (Number.isNaN(target.getTime())) return;

  const root = timer.closest('[data-countdown-root]');
  const message = root?.querySelector('[data-countdown-message]');
  const days = timer.querySelector('[data-countdown-days]');
  const hours = timer.querySelector('[data-countdown-hours]');
  const minutes = timer.querySelector('[data-countdown-minutes]');
  const seconds = timer.querySelector('[data-countdown-seconds]');

  const updateCountdown = () => {
    const distance = target.getTime() - Date.now();

    if (distance <= 0) {
      if (days) days.textContent = '00';
      if (hours) hours.textContent = '00';
      if (minutes) minutes.textContent = '00';
      if (seconds) seconds.textContent = '00';
      message?.classList.add('is-active');
      return;
    }

    const totalSeconds = Math.floor(distance / 1000);
    const dayValue = Math.floor(totalSeconds / 86400);
    const hourValue = Math.floor((totalSeconds % 86400) / 3600);
    const minuteValue = Math.floor((totalSeconds % 3600) / 60);
    const secondValue = totalSeconds % 60;

    if (days) days.textContent = padCountdown(dayValue);
    if (hours) hours.textContent = padCountdown(hourValue);
    if (minutes) minutes.textContent = padCountdown(minuteValue);
    if (seconds) seconds.textContent = padCountdown(secondValue);
  };

  updateCountdown();
  window.setInterval(updateCountdown, 1000);
});

document.querySelectorAll('[data-collection-tabs]').forEach((tabs) => {
  const buttons = Array.from(tabs.querySelectorAll('[data-tab-button]'));
  const panels = Array.from(tabs.querySelectorAll('[data-tab-panel]'));

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
      panels.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === index);
      });
    });
  });
});

const recentlyViewedKey = 'lunova_recently_viewed';
const recentlyViewedProduct = document.querySelector('[data-recently-viewed-product]');

if (recentlyViewedProduct) {
  try {
    const productData = {
      handle: recentlyViewedProduct.dataset.handle,
      title: recentlyViewedProduct.dataset.title,
      url: recentlyViewedProduct.dataset.url,
      image: recentlyViewedProduct.dataset.image,
      price: recentlyViewedProduct.dataset.price,
    };
    const existing = JSON.parse(window.localStorage.getItem(recentlyViewedKey) || '[]')
      .filter((item) => item.handle && item.handle !== productData.handle);
    window.localStorage.setItem(recentlyViewedKey, JSON.stringify([productData, ...existing].slice(0, 8)));
  } catch (error) {
    window.localStorage.removeItem(recentlyViewedKey);
  }
}

document.querySelectorAll('[data-recently-viewed-section]').forEach((section) => {
  const grid = section.querySelector('[data-recently-viewed-grid]');
  if (!grid) return;

  let items = [];
  try {
    items = JSON.parse(window.localStorage.getItem(recentlyViewedKey) || '[]');
  } catch (error) {
    items = [];
  }

  const currentHandle = recentlyViewedProduct?.dataset.handle;
  const limit = Number(section.dataset.limit) || 4;
  const products = items.filter((item) => item.handle && item.handle !== currentHandle).slice(0, limit);

  if (!products.length) return;

  grid.innerHTML = products.map((item) => `
    <article class="recently-viewed-card">
      <a class="recently-viewed-card__image" href="${item.url}">
        ${item.image ? `<img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">` : '<span>L</span>'}
      </a>
      <div>
        <h3><a href="${item.url}">${item.title}</a></h3>
        <p>${item.price}</p>
      </div>
    </article>
  `).join('');
});
